export type PermissionLabel = keyof typeof AllPermissions;
export type PermissionId = (typeof AllPermissions)[keyof typeof AllPermissions];
export const AllPermissions = {
    never: 'never',
    editCompanies: 'edit_companies',
    /** View financial accounts information. */
    viewAccounts: 'view_accounts',
    editRoles: 'edit_roles',
    assignRoles: 'assign_roles',
    editAgencyBranches: 'edit_agency_branches',
    createAgencyBranch: 'create_agency_branch',
    createCampus: 'create_campus',
    editCampuses: 'edit_campuses',
    editPrograms: 'edit_programs',
    editPackages: 'edit_packages',
    /** Edit document types for the system. */
    editDocumentTypes: 'edit_document_types',
    /** Edit qualification levels for the system. */
    editQualificationLevels: 'edit_qualification_levels',
    /** Edit program levels for the system. */
    editProgramLevels: 'edit_program_levels',
    viewAgreementTemplates: 'view_agreement_templates',
    editAgreementTemplates: 'edit_agreement_templates',
    /** Update Application-wide system settings. */
    editSettings: 'edit_settings',
    /** Edit webviews for the system. Example: Landing Page. */
    editWebviews: 'edit_webviews',
    /** Approve company onboarding. */
    approveOnboarding: 'approve_onboarding',
    /** Toggle bank details lock allowing people to change their bank details. */
    toggleBankDetailsLock: 'toggle_bank_details_lock',
    /** View agencies of the system. */
    viewAgencies: 'view_agencies',
    /** Manage agencies of the system. */
    manageAgencies: 'manage_agencies',
    /** View schools of the system. */
    viewSchools: 'view_schools',
    /** Manage schools of the system. */
    manageSchools: 'manage_schools',
    /** View payouts of the system. */
    viewPayouts: 'view_payouts',
    /** Manage payouts of the system, e.g. downloading and reconciling. */
    managePayouts: 'manage_payouts',
    createBranch: 'create_branch',
    /** Edit applications that the user has access to. */
    editApplications: 'edit_applications',
    /** Edit platform referrals settings. */
    editPlatformReferrals: 'edit_platform_referrals',
    viewPartners: 'view_partners',
    editPartners: 'edit_partners',
    explorePartners: 'explore_partners',
    viewAgreements: 'view_agreements',
    /** Update public page of the company. */
    updatePublicPage: 'update_public_page',
    /** Edit email settings for the system. */
    editEmailSettings: 'edit_email_settings',
    /** Manage handlers / managers for students, applications, and partners. */
    manageHandlers: 'manage_handlers',
    manageAgreements: 'manage_agreements',
    /** View all users of the system. */
    viewUsers: 'view_users',
    /** Manage all users of the system. */
    manageUsers: 'manage_users',
    /** View students of the system. */
    viewStudents: 'view_students',
    /** Add students to the system. */
    addStudents: 'add_students',
    /** Manage students of the system. */
    manageStudents: 'manage_students',
    editBankDetails: 'edit_bank_details',
    signAgreements: 'sign_agreements',
    /** Edit company critical details, such as business identification and trading name. */
    editCompanyCriticalDetails: 'edit_company_critical_details',
    /** Log manual or partial payment collections on service payment steps. */
    logManualPayment: 'log_manual_payment',
    /** Confirm or reject manual payment logs submitted by staff. */
    confirmManualPayment: 'confirm_manual_payment',
} as const;
